import styled from 'styled-components';

export const FooterWraper = styled.footer`
  background: linear-gradient(#f9781e, #f9781e78);
  font-weight: bold;
  padding: 2rem 0;
  width: calc(100vw - 240px);
`;
